module.exports = "/_next/static/images/65c8be645ad7e34f9446416cef0853f8-device-frame-dark@0.75x.png.webp";